import React from "react";
import {Button, Tooltip, message} from "antd";
import {CopyOutlined} from "@ant-design/icons";

export const errorOf = (error) => error?.response?.data?.errors || {}

export const copy = async (text) => {
  try {
    await navigator.clipboard.writeText(text)
    message.success('Скопировано')
  } catch (e) {
    window.prompt('Скопируйте ссылку', text)
  }
}

// a link with a copy button
export const CopyLine = ({label, url}) => (
  <div className='link-copy'>
    {label && <span className='link-copy__label'>{label}</span>}
    <Tooltip title={url}><a href={url} target='_blank' rel='noopener noreferrer' className='link-copy__url'>{url}</a></Tooltip>
    <Button size='small' icon={<CopyOutlined/>} onClick={() => copy(url)} aria-label='Скопировать'/>
  </div>
)

// seconds as 1:05 or 1 ч 02 мин
export const formatDuration = (seconds) => {
  const s = Math.round(Number(seconds) || 0)
  if (s >= 3600) return `${Math.floor(s / 3600)} ч ${String(Math.floor((s % 3600) / 60)).padStart(2, '0')} мин`
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`
}

// the steps of the funnel: the clicks (short links only), then Metrika; format: how a value is shown
export const STEPS = [
  {key: 'clicks', title: 'Кликнули', hint: 'переходы по короткой ссылке, без роботов-превью мессенджеров'},
  {key: 'visits', title: 'Перешли', hint: 'визиты на сайт с UTM этой ссылки (Метрика)'},
  {key: 'users', title: 'Людей', hint: 'разные посетители в этих визитах'},
  {key: 'engaged', title: 'Открыли страницу', hint: 'визиты без отказа: человек не закрыл страницу сразу'},
  {key: 'login', title: 'Вошли', hint: 'достигли цели «вход» в этих визитах'},
  {key: 'register', title: 'Зарегистрировались', hint: 'достигли цели «регистрация» в этих визитах'},
  {key: 'long', title: 'Больше 5 минут', hint: 'людей, чей визит длился дольше 5 минут'},
  {key: 'avgTime', title: 'Время на сайте', hint: 'в среднем за визит по ссылке (мин:сек)', format: formatDuration},
]

// a step's value as shown
export const showStep = (step, value) => (step.format ? step.format(value) : value)

// the value of a step for a link (null: not counted for it)
export const stepValue = (link, key) => {
  if (key === 'clicks') return link.clicks ? link.clicks.people : null
  if (!link.metrika || !link.stats) return null
  const value = link.stats[key]
  return value === undefined ? null : value
}

export const UTM_FIELDS = [
  {key: 'utm_source', label: 'Источник', placeholder: 'telegram', required: true,
    options: ['telegram', 'whatsapp', 'max', 'vk', 'email', 'sms', 'instagram', 'site']},
  {key: 'utm_medium', label: 'Канал', placeholder: 'messenger', options: ['messenger', 'email', 'sms', 'social', 'post', 'banner']},
  {key: 'utm_campaign', label: 'Кампания', placeholder: 'osen-2026', required: true, options: []},
  {key: 'utm_content', label: 'Содержание', placeholder: 'knopka-1', options: []},
  {key: 'utm_term', label: 'Ключ', placeholder: '', options: []},
]

// the long link as the server builds it, for the preview
export const previewUrl = (host, path, utm) => {
  try {
    const url = new URL(path || '/', `https://${host}`)
    UTM_FIELDS.forEach(({key}) => {
      if (utm[key]) url.searchParams.set(key, utm[key])
    })
    return url.toString()
  } catch (e) {
    return ''
  }
}

// pages of the portal for links that lead there
export const PORTAL_PAGES = [
  {value: '/login', label: 'Вход и регистрация'},
  {value: '/residential-complexes', label: 'База квартир'},
  {value: '/promotions', label: 'Акции'},
  {value: '/motivation', label: 'Мотивация'},
]
